import { getSectionsDictionary } from '~/src/repositories/cms/shared/cms.base.repository';
import { CmsCategoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getMappedPartnersData } from '~/src/repositories/cms/entities/partners/utils/cms.partners.utils';

export const getAllPartnersProducts = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary({ isSSR, categoryCode: CmsCategoryCodeEnum.PARTNERS_PRODUCTS });
    const mappedData = getMappedPartnersData(data);
    const productsTypes = {
        productsParters: 'Produkti_partnyorov',
        productsMtsEcosystem: 'Produkti_ekosistemi_MTS',
    };
    const getProductsByType = (type: string) => mappedData.map((elem) => elem.filter((elem) => elem?.type === type));
    return {
        externalPartnersProducts: getProductsByType(productsTypes.productsParters),
        mtsProductsEcosystem: getProductsByType(productsTypes.productsMtsEcosystem),
    };
};
